import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {
  Divider,
  IconButton,
  styled,
  Toolbar,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';

import { AppBarProps, CustomAppBarProps } from './props';

const StyledAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<CustomAppBarProps>(({ theme, open, drawerwidth }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  boxShadow: 'none',
  display: 'flex',
  alignItems: 'center',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(!open && {
    [theme.breakpoints.up('xl')]: {
      width: `calc(100% - ${theme.spacing(20)} + 1px)`,
      marginLeft: `${theme.spacing(20)} + 1px)`,
    },
  }),
  ...(open && {
    [theme.breakpoints.up('xl')]: {
      marginLeft: drawerwidth,
      width: `calc(100% - ${drawerwidth}px)`,
    },
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const AppBar: React.FC<AppBarProps> = (props) => {
  const { children, handleDrawerToggle, open, drawerWidth = 0 } = props;

  // ======================= HOOKS
  const theme = useTheme();
  // ======================= VIEWS
  return (
    <StyledAppBar position={'fixed'} open={open} drawerwidth={drawerWidth}>
      <Toolbar
        className="px-4"
        sx={{ maxWidth: `calc(1440px - 3rem)`, width: '100%' }}
      >
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { xl: open ? 'none' : 'flex' } }}
        >
          <MenuIcon />
        </IconButton>
        {children}
      </Toolbar>
      <Divider
        variant={
          useMediaQuery(theme.breakpoints.down('xl')) ? 'fullWidth' : 'middle'
        }
      />
    </StyledAppBar>
  );
};

// ======================= EXPORT
export default AppBar;
